import { Grid, makeStyles } from '@material-ui/core';
import { FormHookResult } from 'design-system';

const useStyles = makeStyles({
  honey: {
    opacity: 0,
    position: 'absolute',
    top: 0,
    left: 0,
    height: 0,
    width: 0,
    zIndex: -1,
  },
});

type Props = {
  potName: string;
  getInputProps: FormHookResult;
};

const HoneyPot = ({ potName, getInputProps }: Props): JSX.Element => {
  const classes = useStyles();
  return (
    <Grid item xs={12}>
      <input
        className={classes.honey}
        data-testid="alterName-field"
        name={potName}
        type="text"
        defaultValue={getInputProps(potName).value as string}
        onChange={(e) => getInputProps(potName).onChange(e.target.value)}
      />
    </Grid>
  );
};

export default HoneyPot;
